module.exports = __webpack_public_path__ + "0822be7346b362edaf4fa6cf07de97a7.png";